import { crude } from './crude'
import { lng } from './lng';
import { lpg } from './lpg';
import { admin } from './admin'
import { ref } from './reference'
import { NavigationCombined, Projects } from "./type";

export const getNavigation = (self: Projects, include: Array<Projects> = [ 'crude', 'lng', 'lpg', 'admin', 'ref' ], isDev: boolean, skipHome?: boolean): Array<NavigationCombined> => {
  let urlPrefix = ``;
  if ( isDev ) {
    urlPrefix = `http://localhost:4210`;
  }
  const map: Record<Projects, (internal: boolean, urlPrefix: string) => NavigationCombined> = {
    crude,
    lng,
    lpg,
    admin,
    ref
  };
  const apps = include
    .map(p => map[ p ](self === p, urlPrefix))
    .sort((a, b) => {
      if ( !skipHome && (a.app === self) ) {
        return -1;
      }
      if ( !skipHome && (b.app === self) ) {
        return 1;
      }
      return a.order - b.order
    })
  if ( skipHome ) {
    return apps;
  }
  return [
    {
      app: 'admin',
      order: 4,
      label: 'Home',
      icon: 'home',
      flat: true,
      prefix: '',
      title: 'Home',
      link: self !== 'admin' ? `${ urlPrefix }/` : null,
      route: self === 'admin' ? [ '/' ] : null
    },
    ...apps
  ];
}
